import { jsxs as i, jsx as t } from "react/jsx-runtime";
import { cloneElement as n } from "react";
import { useMultiStyleConfig as f, Tag as g, TagLabel as l } from "@chakra-ui/react";
import { IconButton as p } from "../../forms/Button/IconButton.mjs";
import { faXmark as c } from "@fortawesome/pro-light-svg-icons/faXmark";
import { FontAwesomeIcon as x } from "@fortawesome/react-fontawesome";
const j = ({
  children: o,
  leftIcon: e,
  onCloseClick: m,
  showCloseButton: r = !1,
  ...a
}) => {
  const s = f("Tag");
  return /* @__PURE__ */ i(g, { colorScheme: r ? "gray" : "teal", ...a, children: [
    e && n(e, {
      size: "sm"
    }),
    /* @__PURE__ */ t(l, { children: o }),
    r && /* @__PURE__ */ t(
      p,
      {
        "aria-label": `Remove ${typeof o == "string" || typeof o == "number" ? `${o} ` : ""}tag`,
        sx: s.closeButton,
        variant: "ghost",
        icon: /* @__PURE__ */ t(x, { icon: c, size: "xs", viewBox: "0 100 320 320" }),
        onClick: m
      }
    )
  ] });
};
export {
  j as Tag
};
